import React from 'react'
import axios from 'axios';
import { useCart ,useDispatchCart } from '../Components/ContextReducer';




export default function Cart() {
  let data = useCart();
  let dispatch = useDispatchCart();
  if (data.length === 0) {
    return (
      <div>
        <div className='m-5 w-100 text-center text-white fs-3'>The Cart is Empty!</div>
      </div>
    )
  }
 

 
  let totalPrice = data.reduce((total, food) => total + food.price, 0)

  // const {id,name,qty,size,price,img}=data

const handleCheckout= async()=>{
  let userEmail= localStorage.getItem("UserEmail");
  await axios.post('https://gofoodies.onrender.com/createOrder',{
    email:userEmail,
    order_data:data,
    order_date:new Date().toDateString()

  })
  .then(result=>{
    console.log(result.status)
    alert("Order Place succesfully")
    dispatch({type:"DROP"})
})
.catch(err=>{
  console.log(err.response.data.msg)
  alert(err.response.data.msg)
})
   
}




  return (
    <div>

      {console.log(data)}
      <div className='container m-auto mt-5 table-responsive  table-responsive-sm table-responsive-md' >
        <table className='table table-hover '>
          <thead className=' text-success fs-4'>
            <tr>
              <th scope='col' >#</th>
              <th scope='col' >Name</th>
              <th scope='col' >Quantity</th>
              <th scope='col' >Option</th>
              <th scope='col' >Amount</th>
              <th scope='col' ></th>
            </tr>
          </thead>
          <tbody>
            {data.map((food, index) => (
              <tr className='text-white' >
                <th scope='row' >{index + 1}</th>
                <td >{food.name}</td>
                <td>{food.qty}</td>
                <td>{food.size}</td>
                <td >{food.price}</td>
                <td ><button type="button" className="btn p-0 bg-danger " onClick={()=>{dispatch({type:"REMOVE",index:index})}}>x</button> </td></tr>
            ))}
          </tbody>
        </table>
        <div><h1 className='text-white fs-2'>Total Price: {totalPrice}/-</h1></div>
        <div>
          <button className='btn bg-success mt-5 ' onClick={handleCheckout} > Order Place </button>
        </div>
      </div>



    </div>
  )
}